

module.exports = __webpack_require__.stylable.create(
    "FollowBtn158509262",
    {"classes":{"root":"FollowBtn158509262__root","InstagramIcon":"FollowBtn158509262__InstagramIcon","WarpFollowBtn":"FollowBtn158509262__WarpFollowBtn","Items":"FollowBtn158509262__Items"},"vars":{},"stVars":{"ShowMoreColorGrid":"\"fallback(color(--showMoreColorGrid), color(color-5))\"","ButtonTextAndIconsColorHover":"\"fallback(color(--buttonTextAndIconsColorHover), color(color-5))\""},"keyframes":{}},
    "",
    15,
    "FollowBtn158509262",
    null
);
